"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var json_1 = require("../../../../common/helpers/json");
var drive_types_1 = require("../../../../common/types/drive.types");
var saveToDisk_1 = require("../../../../common/helpers/saveToDisk");
var AdminStudentDrivesController = /** @class */ (function () {
    function AdminStudentDrivesController($stateParams, UsersModel, $window) {
        var _this = this;
        this.$stateParams = $stateParams;
        this.date = new Date();
        this.currentPage = 1;
        this.$window = $window;
        this.UsersModel = UsersModel;
        this.busy = false;
        this.handleStudentDrives = this.handleStudentDrives.bind(this);
        this.formatDrive = this.formatDrive.bind(this);
        UsersModel.getStudentDrives({
            id: $stateParams.userId,
            page_results: false,
        }).then(this.handleStudentDrives);
        UsersModel.getStudentByID($stateParams.userId).then(function (response) {
            _this.student = response;
        });
    }
    AdminStudentDrivesController.prototype.formatDrive = function (drive) {
        Object.assign(drive, (0, drive_types_1.formatDriveForDisplay)(drive));
        if (drive.instructor) {
            var license = drive.instructor.usermeta.filter(function (usermeta) {
                return usermeta.meta_key === "license";
            })[0].meta_value;
            drive.instructor.license = (0, json_1.isJson)(license)
                ? JSON.parse(license).number
                : license;
        }
        if (drive.observation === true) {
            drive.type.name = drive.type.name + " (Observation)";
        }
        return drive;
    };
    AdminStudentDrivesController.prototype.handleStudentDrives = function (response) {
        this.drives = response.drives.filter(this.formatDrive);
    };
    AdminStudentDrivesController.prototype.print = function () {
        this.$window.print();
    };
    AdminStudentDrivesController.prototype.download = function () {
        var _this = this;
        this.busy = true;
        this.UsersModel.exportStudentDrives(this.$stateParams.userId)
            .then(function (response) {
            var filename = response.report_url.split("/")[response.report_url.split("/").length - 1];
            (0, saveToDisk_1.saveToDisk)(response.report_url, filename);
            _this.busy = false;
        })
            .catch(function () {
            _this.busy = false;
        });
    };
    return AdminStudentDrivesController;
}());
AdminStudentDrivesController.$inject = [
    "$stateParams",
    "UsersModel",
    "$window",
];
exports.default = AdminStudentDrivesController;
